import * as mainTerms from '../mainTerms';

const advertiserDef = mainTerms.Setting.advertiser.default;
export const SetAdvertiser = {
    deleteAdvertiser: {
        success: '정상적으로 삭제되었습니다.',
        error: {
            fail: '정상적으로 삭제되지 못했습니다.\n다시 시도해주세요.',
        },
    },
    getResponse: {
        error: {
            fail: '정상적으로 데이터를 읽어오지 못했습니다.\n페이지를 갱신해주세요.',
        },
    }
}

export const EditAdvertiser = {
    new: {
        success: '새로운 ' + advertiserDef + '가 생성되었습니다.',
        error: {
            fail: advertiserDef + ' 생성에 실패했습니다.\n다시 시도해주세요.',
        },
    },
    editing: {
        success: '작성하신 내용이 반영되었습니다.',
        error: {
            getAdvertiserInfo: '정상적으로 데이터를 읽어오지 못했습니다.\n페이지를 갱신해주세요.',
            fail: '작성하신 내용을 반영하지 못했습니다.\n다시 시도해주세요.',
            notFound: '해당 ' +advertiserDef+ '가 존재하지 않습니다.',
        },
    },
    other: {
        confirm: {
            warnIsModified: '변경 중인 내용은 저장되지 않습니다.\n정말 취소하시겠습니까?',
        },
    },
}